exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-logo {\n  text-align: center; }\n\n.auth-block p {\n  text-align: center; }\n\n.auth-block {\n  background: #bf0a24 !important; }\n\n.funds-separator {\n  border-bottom: solid 1px #abb9be;\n  padding: 10px 0; }\n\n.funds-separator:last-child {\n  border-bottom: none; }\n\n.search--input {\n  margin-left: 0px;\n  padding-left: 10px;\n  width: 300px;\n  margin-bottom: 10px; }\n\n.table-hover > tbody > .active:before {\n  background-color: rgba(0, 0, 0, 0.1); }\n\n.container-content {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex; }\n  .container-content ba-checkbox {\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMultiCheckbox/baMultiCheckbox.scss
// module id = 833
// module chunks = 8